import React, { useEffect } from "react";
import UseContext from "hooks/useContext";
import useFetchData from "hooks/useFetchData";
import SectionWrapper, {
    FormField,
    inputClassName,
    textareaClassName,
} from "pages/createMission/components/SectionWrapper";
import Divider from "components/divider/divider";

const InfoTemplate = () => {
    const { templateData, setTemplateData } = UseContext();
    const { userData } = useFetchData();

    useEffect(() => {
        if (userData?.firstname && userData?.lastname) {
            if (
                templateData.contact_name !== undefined &&
                templateData.contact_name === ""
            ) {
                setTemplateData((prev) => ({
                    ...prev,
                    contact_name:
                        userData.firstname + " " + userData.lastname,
                }));
            }
            if (
                templateData.contact_poste !== undefined &&
                templateData.contact_poste === ""
            ) {
                setTemplateData((prev) => ({
                    ...prev,
                    contact_poste: "Responsable",
                }));
            }
        }
    }, [userData]); // eslint-disable-line

    return (
        <div className={"flex flex-col gap-6"}>
            <SectionWrapper
                title="Responsable"
                description="Indiquez les informations du responsable rattaché à cette fiche."
            >
                <FormField label="Nom complet du responsable">
                    <input
                        name="contact_name"
                        value={templateData.contact_name}
                        onChange={(e) =>
                            setTemplateData((prev) => ({
                                ...prev,
                                contact_name: e.target.value,
                            }))
                        }
                        className={inputClassName}
                        type="text"
                        required
                    />
                </FormField>
                <FormField label="Fonction">
                    <input
                        name="contact_poste"
                        value={templateData.contact_poste}
                        onChange={(e) =>
                            setTemplateData((prev) => ({
                                ...prev,
                                contact_poste: e.target.value,
                            }))
                        }
                        className={inputClassName}
                        type="text"
                        required
                    />
                </FormField>
            </SectionWrapper>
            <SectionWrapper
                title="Informations supplémentaires"
                description="Profitez de cet espace pour préciser des informations supplémentaires que les candidats devraient avoir."
            >
                <FormField
                    label="Informations pour le candidat sélectionné"
                    optional
                >
                    <textarea
                        name="other"
                        rows="5"
                        className={textareaClassName}
                        value={templateData.other}
                        maxLength={500}
                        onChange={(e) =>
                            setTemplateData((prev) => ({
                                ...prev,
                                other: e.target.value,
                            }))
                        }
                    />
                </FormField>
                <Divider />
                <FormField label="Informations pour l'agence d'intérim" optional>
                    <textarea
                        name="other_interim"
                        rows="5"
                        className={textareaClassName}
                        value={templateData.other_interim}
                        maxLength={500}
                        onChange={(e) =>
                            setTemplateData((prev) => ({
                                ...prev,
                                other_interim: e.target.value,
                            }))
                        }
                    />
                </FormField>
            </SectionWrapper>
        </div>
    );
};

export default InfoTemplate;
